// eg ssh-rsa base_64_key optional_comment
// honcho actually has a list of key types that are supported; but keep the gui validation
// simpler so that both things don't have to be in sync.
const OPENSSH_PUB_KEY_LINE = /^[-_0-9a-z]+ [A-Za-z0-9=/+]{16,}(?: .+)?/;

export function validateSshKeys(v: string): [?string, ?string] {
    const lines = v.split("\n");
    let error: null|string = null;

    lines.forEach((line, idx) => {
        if (error == null && line !== '' && !OPENSSH_PUB_KEY_LINE.test(line)) {
            error = `Invalid key at line ${idx + 1}`;
        }
    });

    if (error) return [error, null];

    return [null, v];
}